import { useTranslation } from 'react-i18next';
import './styles.css';

export const NeedHelp = () => {
  const { t } = useTranslation();
  return (
    <div className="mainHelp">
      <div>
        <p>{t('need_help_contact_us')}</p>
      </div>
      <a href="/#contactUs">{t('need_help_contact_us_button')}</a>
    </div>
  );
};

export default NeedHelp;
